import Grid from "@mui/material/Unstable_Grid2/Grid2"

import CriarEditarLivroAta from "./CriarEditarLivroAta/CriarEditarLivroAta"
import ListarLivroAta from "./ListarLivroAta/ListarLivroAta"
import { useContext, useState } from "react"
import { WebSocketContext } from "../../Providers/WebSocket/WebSocketContext"
import { Button, Typography } from "@mui/material"
import { ReceiptLong } from "@mui/icons-material"

const LivroAta = () => {
    const [idEdit, setIdEdit] = useState()
    const [filtros, setFiltros] = useState({})
    const { sendWs } = useContext(WebSocketContext)
    const getDados = () => {
        sendWs("buscarTodasObs", { filtros })
    }

    const [acao, setAcao] = useState('insere')
    return (
        <>
            <Grid sx={{ gap: '7px', alignItems: 'self-start', height: '100%', width: '100%' }} >
                <Grid item sx={{ height: '28px', paddingBottom: '5px' }}>
                    <Typography
                        sx={{
                            color: 'white',
                            fontSize: '20px',
                            fontWeight: 'bold'
                        }}><ReceiptLong sx={{
                            height: '18px'
                        }}/> - Livro Ata - {acao == 'insere' ? 'Inserindo um novo' : 'Editando registro'}</Typography>
                </Grid>
                <Grid item sx={{ minHeight: '150px', height: '27%', paddingBottom: '5px' }}>
                    <CriarEditarLivroAta setIdEdit={setIdEdit} idEdit={idEdit} filtros={filtros} setFiltros={setFiltros} setAcao={setAcao} />
                </Grid>
                <Grid item xs={12} sx={{
                    height: {
                        lg: '66%',
                        xl: '69%'
                    },
                    width: '100%'
                }}>
                    <ListarLivroAta setIdEdit={setIdEdit} filtros={filtros} setFiltros={setFiltros}/>
                </Grid>
                <Button
                    sx={{ display: 'none' }}
                    onClick={getDados}
                    id="livroAtaGetDados"
                >
                    Pegar dados
                </Button>
            </Grid>
        </>
    )
}

export default LivroAta
